module.exports = __webpack_public_path__ + "img/IMG_9022_L_Black.40bef2fc.jpg";